/**
 * Save or update a user's garden layout
 * @param {Object} data - Garden data
 * @param {string} data.name - Name of the garden
 * @param {string} data.soil_type - Soil type
 * @param {string} data.hardiness_zone - Hardiness zone
 * @param {string} data.sunlight - Sunlight conditions
 * @param {string} data.maintenance - Maintenance level
 * @param {Array} data.matrix - Garden matrix
 * @returns {Promise<{error: null | string, gardenId?: number}>}
 */
export async function saveGardenToDB(data) {
    try {
        const response = await fetch('/api/gardens/save', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();
        console.log('API Response:', result); // Debug log

        if (!response.ok) {
            return { error: result.error || 'Failed to save garden' };
        }

        // Debug the data structure
        console.log('Result data:', result.data);
        console.log('Garden ID:', result.data?.[0]?.id);

        return { error: null, gardenId: result.data?.[0]?.id };
    } catch (err) {
        console.error('Error saving garden:', err);
        return { error: 'Network error' };
    }
}

/**
 * Save garden plants to the database
 * @param {Object} data - Plant data
 * @param {number} data.gardenId - Garden ID
 * @param {Array} data.plantMap - Array of plant objects (can include nulls)
 * @param {number} data.gardenWidth - Width of the garden grid
 * @returns {Promise<{error: null | string, plantsCount?: number}>}
 */
export async function saveGardenPlantsToDB(data) {
    console.log('Saving plants with data:', data); // Debug log

    try {
        const response = await fetch('/api/gardens/savePlants', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();
        console.log('Plants API Response:', result); // Debug log

        if (!response.ok) {
            return { error: result.error || 'Failed to save plants' };
        }

        return { error: null, plantsCount: result.plantsCount };
    } catch (err) {
        console.error('Error saving plants:', err);
        return { error: 'Network error' };
    }
}